import { defineComponent as _defineComponent } from 'vue'
import FloatingActionButton from "@/components/buttons/FloatingActionButton.vue";

import BankAccountEdit from "@/components/BankAccountEdit.vue";

import EmployeeEdit from "@/components/EmployeeEdit.vue";

import AddressEdit from "@/components/AddressEdit.vue";

import {operatorDataPolicies} from "@/authorization/policies/operatorDataPolicies";

import {
  getAccessRights,
} from "@/authorization";

import {
  computed,
  onMounted,
  ref,
  unref,
} from "vue";

import {
  createEmptyOperator,
  operatorHasChanges,
  resetOperatorObject,
} from "@/components/operator/scripts/operatorActions";

import type {
  Operator,
} from "@/components/operator/scripts";

import {
  createOrUpdateOperator,
  fetchOperator,
  MAX_LENGTH_COMPANY_NAME,
  MAX_LENGTH_PRODUCT_NAME,
} from "@/components/operator/scripts";

import {
  httpMethod,
} from "@/scripts/Common/api";

import {
  hasSepaCondition,
  hasValidLengthOnSepaCondition,
  isRequired,
} from "@/scripts/Common/validators";

import {
  copyObject,
} from "@/scripts/Common/HelperFunctions";

import ProvisionAndLimiteOverview from "@/components/operator/childrens/ProvisionAndLimiteOverview.vue";

import {
  countCharacterSepaField,
  getInvalidCharacters
} from "@/scripts/Common/helpers";

import {
  SEPA_CHARACTER_REPLACER_REGEX,
} from "@/scripts/Constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'OperatorManagement',
  emits: [
  'onFetchError'
],
  setup(__props, { emit: emits }) {

const {
  hasEditRights,
} = getAccessRights(operatorDataPolicies);



const onHandleFetchError = ({error}: {
  error: any
}) => {
  emits('onFetchError', {error})
};

const operator = ref<Operator>(createEmptyOperator());
const initialOperatorData = ref<Operator>(createEmptyOperator());

const panelExpander = ref([1]);

const operatorValid = ref(true);
const contactEmployeeValid = ref(true);
const contactAddressValid = ref(true);
const businessBankAccountValid = ref(true);
const escrowBankAccountValid = ref(true);
const provisionsValid = ref(true);

const operatorForm = ref();

const isNewOperator = computed(() => operator.value?.id === 0);

const canEdit = computed(() => hasEditRights)

const hasChanges = computed(() => operatorHasChanges(unref(initialOperatorData), unref(operator)))

const canSave = computed(() => {
  return canEdit.value
    && operatorValid.value
    && contactEmployeeValid.value
    && businessBankAccountValid.value
    && escrowBankAccountValid.value
    && provisionsValid.value
    && hasChanges.value;
})

const loadOperator = async () => {
  const {response, error} = await fetchOperator();

  if (error) {
    onHandleFetchError({error});
    return;
  }

  operator.value = response ?? createEmptyOperator();
  initialOperatorData.value = copyObject(operator.value);
}

const validate = () => {
  operatorForm.value?.validate();
}

const onHandleReset = () => {
  if(!isNewOperator.value){
    panelExpander.value = [1];
  }

  resetOperatorObject(unref(initialOperatorData), unref(operator));
}

const onHandleSave = async () => {
  const {response, error} = isNewOperator.value
    ? await createOrUpdateOperator(unref(operator), httpMethod.POST)
    : await createOrUpdateOperator(unref(operator), httpMethod.PUT);

  if (error) {
    onHandleFetchError({error});
    return;
  }

  operator.value = response ?? createEmptyOperator();
  initialOperatorData.value = copyObject(operator.value);
}

const onHandleCreateProcess = () => {
  validate();
}

onMounted(async () => {
  await loadOperator();

  if (isNewOperator.value) {
    onHandleCreateProcess();
  }
});

return { __sfc: true,hasEditRights, emits, onHandleFetchError, operator, initialOperatorData, panelExpander, operatorValid, contactEmployeeValid, contactAddressValid, businessBankAccountValid, escrowBankAccountValid, provisionsValid, operatorForm, isNewOperator, canEdit, hasChanges, canSave, loadOperator, validate, onHandleReset, onHandleSave, onHandleCreateProcess, FloatingActionButton, BankAccountEdit, EmployeeEdit, AddressEdit, MAX_LENGTH_COMPANY_NAME, MAX_LENGTH_PRODUCT_NAME, hasSepaCondition, hasValidLengthOnSepaCondition, isRequired, ProvisionAndLimiteOverview, countCharacterSepaField, getInvalidCharacters, SEPA_CHARACTER_REPLACER_REGEX }
}

})